<co-image [width]="view.iconWidth" [height]="view.iconHeight" [cssClass]="imageStyle" [isVault]="view.isVaultIcon" [key]="view.icon"></co-image>
<span *ngIf="selected" class="select-box">
  <span class="transparent-circle-back"></span>
  <span class="transparent-circle">
    <co-image width="20" height="20" type="svg" key="checkmark"></co-image>
  </span>
</span>